import React, { useEffect } from 'react'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { referenceActions } from '../../store/actions'
import { connect } from 'react-redux'
import history from '../../route/history'
import * as Common from '../../assets/js/common.js'

const ReferenceDetail = (props) => {
  const queryString = require('query-string')

  useEffect(() => {
    props.detail(props.seq, props.searchInfo)
  }, [props.seq])

  const goList = () => {
    let paramStr = queryString.stringify(props.searchInfo)
    paramStr.length > 0 && (paramStr = '?' + paramStr)
    history.push('/reference' + paramStr)
  }

  const fileDownload = (url, originFileNm) => {
    // 정책 변경 시 추가 작업 해야함...
    console.log('url', url)
    console.log('originFileNm', originFileNm)
    window.M.pop.alert('IOS 정책이 변경되어 WEB에서만 다운로드가 가능합니다.')

    // var outputFilePath = '/storage/emulated/0/Download/test/' + originFileNm
    // window.M.execute(
    //   'exWNFileDownload',
    //   url,
    //   outputFilePath,
    //   window.M.response
    //     .on(function (status, result) {
    //       console.log('status', status)
    //       console.log('result', JSON.stringify(result))
    //       window.M.pop.alert('IOS 정책이 변경되어 WEB에서만 다운로드가 가능합니다.')
    //     })
    //     .toString(),
    // )
  }

  return (
    <React.Fragment>
      <ul className="view-board">
        <li className="view-title">
          <h3>
            {props.select?.noticeSj}
            {props.select?.ptlFileDtoList?.length > 0 ? <i className="file">첨부파일</i> : null}
          </h3>
        </li>
        <li className="view-info">
          <div className="left">
            <span className="tit">등록일</span>
            <em>{moment(props.select?.regDt).format('YYYY.MM.DD')}</em>
          </div>
          <div className="right">
            <span className="tit">조회수</span>
            <em>{props.select?.viewCount}</em>
          </div>
        </li>
        <li className="view-attach">
          <div className="tit">첨부파일</div>
          <ul className="attach-list">
            {props.select?.ptlFileDtoList?.map((item, idx) => {
              return (
                <React.Fragment key={'list' + idx}>
                  {Common.getDeviceType() === 'MobileApp' && window.M.navigator.device('ios') ? (
                    <a
                      href="#"
                      onClick={() => fileDownload(process.env.REACT_APP_API_URL + '/portal/file/' + item?.encryptedId, item.originFileNm)}
                      title="첨부파일"
                      download
                    >
                      (첨부{idx + 1}) {item.originFileNm}
                    </a>
                  ) : (
                    <a href={process.env.REACT_APP_API_URL + '/portal/file/' + item?.encryptedId} title="첨부파일" download>
                      (첨부{idx + 1}) {item.originFileNm}
                    </a>
                  )}
                  <br />
                </React.Fragment>
              )
            })}
          </ul>
        </li>
        <li className="view-cont">
          {props.select?.noticeText?.split('\n').map((line, idx) => {
            return (
              <span key={'noticeText' + idx}>
                {line}
                <br />
              </span>
            )
          })}
        </li>
      </ul>
      <ul className="prev-next">
        {props.prev !== null ? (
          <li>
            {' '}
            <Link title="다음글" to={{ pathname: '/reference/' + props.prev?.noticeSeq, state: props.searchInfo }}>
              <span>다음</span>
              {props.prev?.noticeSj}
            </Link>
          </li>
        ) : (
          <li>
            <span>다음</span> 다음 글이 없습니다.
          </li>
        )}

        {props.next !== null ? (
          <li>
            {' '}
            <Link title="이전글" to={{ pathname: '/reference/' + props.next?.noticeSeq, state: props.searchInfo }}>
              <span>이전</span>
              {props.next?.noticeSj}
            </Link>
          </li>
        ) : (
          <li>
            <span>이전</span> 이전 글이 없습니다.
          </li>
        )}
      </ul>
      <div className="btn-block">
        <span className="right">
          <a href="#" className="btn-primary md" onClick={goList}>
            목록
          </a>
        </span>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    select: state.reference.select,
    prev: state.reference.prev,
    next: state.reference.next,
  }
}
const actionCreators = {
  detail: referenceActions.detail,
}

export default connect(mapStateToProps, actionCreators)(ReferenceDetail)
